import { useEffect, useState } from 'react';

export type DeviceTier = 'off' | 'low' | 'high';

function computeTier(): DeviceTier {
  if (typeof window === 'undefined') return 'high';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return 'off';

  const nav = navigator as Navigator & {
    deviceMemory?: number;
    connection?: { saveData?: boolean };
  };

  const isNarrow = window.matchMedia('(max-width: 768px)').matches;
  const lowCores = (nav.hardwareConcurrency ?? 8) <= 4;
  const lowMemory = (nav.deviceMemory ?? 8) <= 4;
  const saveData = !!nav.connection?.saveData;

  if (isNarrow || lowCores || lowMemory || saveData) return 'low';
  return 'high';
}

// Detecta si el dispositivo es de gama baja/media o pide movimiento reducido,
// para bajar el costo del fondo 3D (menos partículas, sin post-procesado).
export function useDeviceTier(): DeviceTier {
  const [tier, setTier] = useState<DeviceTier>(computeTier);

  useEffect(() => {
    const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const widthQuery = window.matchMedia('(max-width: 768px)');
    const update = () => setTier(computeTier());
    motionQuery.addEventListener('change', update);
    widthQuery.addEventListener('change', update);
    return () => {
      motionQuery.removeEventListener('change', update);
      widthQuery.removeEventListener('change', update);
    };
  }, []);

  return tier;
}
